import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Creates (or reuses) the draft's Stripe recipient and returns a single-use
 * hosted-form URL; the browser navigates there and comes back to `returnUrl`.
 */
export const startStripeRefundRecipientOnboarding = {
  name: "startStripeRefundRecipientOnboarding" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    returnUrl: z.string().url(),
  }),
  output: z.object({ providerAccountId: z.string(), url: z.string().url() }),
};
